/**
 * Maps scheduler /status transitions to user-facing toast notifications.
 * Returns null when no notification should be shown (e.g. initial load).
 */
export function getSchedulerStatusNotification(previousStatus, nextStatus) {
  if (!previousStatus || !nextStatus) {
    return null;
  }

  const prev = previousStatus.status;
  const next = nextStatus.status;
  const wasRunning = Boolean(previousStatus.is_running);
  const isRunning = Boolean(nextStatus.is_running);

  if (prev !== 'running' && next === 'running' && isRunning) {
    return {
      type: 'started',
      title: 'Scheduler started',
      message: 'Planning run is in progress.',
    };
  }

  if (prev === 'running' && next === 'waiting') {
    let message = 'Planning complete — waiting for next run.';
    if (next.next_run_time) {
      try {
        const nextRun = new Date(next.next_run_time);
        const formatted = nextRun.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
        });
        message = `Planning complete — next run at ${formatted}.`;
      } catch {
        // keep default message
      }
    }
    return {
      type: 'waiting',
      title: 'Waiting for next run',
      message,
    };
  }

  if (wasRunning && !isRunning && next === 'stopped') {
    const runCount = next.run_count ?? 0;
    const message =
      runCount > 0
        ? `Planning complete — scheduler stopped after ${runCount} run${runCount === 1 ? '' : 's'}.`
        : 'Scheduler has been stopped.';
    return {
      type: 'stopped',
      title: 'Scheduler stopped',
      message,
    };
  }

  return null;
}
